<template>
    <div :style="$vuetify.breakpoint.smAndDown ? 'padding: 0 !important' : 'padding: 0 15% !important'">
        <p-loader></p-loader>
        <p-snackbar></p-snackbar>
        <v-layout>
            <router-view/>
        </v-layout>
    </div>
</template>

<script>
  /* eslint-disable template-curly-spacing */
  import PLoader from './../shared/PLoader'
  import PSnackbar from './../shared/PSnackbar'

  export default {
    name: 'shared',
    components: {PSnackbar, PLoader},
    data: function () {
      return {
        backgroundImage: ''
      }
    },
    mounted: function () {
    }
  }
</script>

<style>
/* Quebra de linha em palavra */
  .break-word {
    word-break: break-word;
  }
  /* Quebra de linha em caracter */
  .break-all {
    word-break: break-all;
  }
  /* As frases terão apenas uma linha */
  .one-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  /* As frases terão apenas 2 linha */
  .two-line {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Shared.vue